/** Formatting controls. Labels drive the command, as in the prototype. */
const TOOLBAR_COMMANDS: ReadonlyArray<
  { label: string; command: string; value?: string; content: React.ReactNode } | { divider: true }
> = [
  { label: "Bold", command: "bold", content: <strong>B</strong> },
  { label: "Italic", command: "italic", content: <em>I</em> },
  { label: "Underline", command: "underline", content: <u>U</u> },
  { divider: true },
  { label: "Bulleted list", command: "insertUnorderedList", content: "• List" },
  { label: "Numbered list", command: "insertOrderedList", content: "1. List" },
  { divider: true },
  { label: "Normal text", command: "formatBlock", value: "p", content: "Normal" },
  { label: "Heading 1", command: "formatBlock", value: "h2", content: "H1" },
  { label: "Heading 2", command: "formatBlock", value: "h3", content: "H2" },
];

export function EditorToolbar({
  trackingActive,
  focusMode,
  onCommand,
  onToggleFocusMode,
}: {
  trackingActive: boolean;
  focusMode: boolean;
  onCommand: (command: string, value?: string) => void;
  onToggleFocusMode: () => void;
}) {
  return (
    <div className="toolbar" role="toolbar" aria-label="Editor formatting tools">
      {TOOLBAR_COMMANDS.map((item, index) =>
        "divider" in item ? (
          // eslint-disable-next-line react/no-array-index-key
          <span className="divider" key={`divider-${index}`} />
        ) : (
          <button
            key={item.label}
            type="button"
            aria-label={item.label}
            // Keep focus in the editor. Without this, every toolbar press
            // blurs and refocuses the surface, which the tracker would record
            // as the student leaving and re-entering the writing area — two
            // false focus changes per click, plus a spurious session end time.
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => {
              // Formatting is inert until the writing session has started.
              if (!trackingActive) return;
              onCommand(item.command, item.value);
            }}
          >
            {item.content}
          </button>
        ),
      )}
      <span className="divider" />
      <button
        className={`focus-toggle ${focusMode ? "active" : ""}`.trim()}
        type="button"
        aria-pressed={focusMode}
        aria-label={focusMode ? "Exit Focus Mode" : "Focus Mode"}
        onMouseDown={(event) => event.preventDefault()}
        onClick={onToggleFocusMode}
      >
        <span aria-hidden="true">⛶</span>
      </button>
    </div>
  );
}
